import { useRef, useState } from 'react';
import { Row, Col, Modal, Button, Form } from 'react-bootstrap';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import Flatpickr from 'react-flatpickr';
import { MemberMultiSelectDropdown, ProjectListDropdown } from '../common';

const PublishSchedules = ({
  teamMembersList,
  projectsList,
  showPublishSchedules,
  handleShowPublishSchedules,
  handlePublishSchedules,
  selectedProject,
  handleProjectChange,
}) => {
  const selectedTeamMembers = [];
  const sortedMembersList = teamMembersList.filter(function (el) {
    return el.status !== 'inactive';
  });
  const publishSchedulesSelectInputRef = useRef(null);
  const datePickerOptions = {
    allowInvalidPreload: true,
    dateFormat: 'M j, Y',
    monthSelectorType: 'static',
    minDate: 'today',
  };

  // Clear the team member field when project changes
  const clearTeamMemberFiled = () => {
    if (!publishSchedulesSelectInputRef.current) return;
    publishSchedulesSelectInputRef.current.select.clearValue();
  };
  const [selectedTeamMember, setSelectedTeamMember] = useState([]);

  const handleTeamMembers = (values) => {
    setSelectedTeamMember(values);
  };
  return (
    <Modal
      show={showPublishSchedules}
      onHide={() => {
        handleShowPublishSchedules(false);
      }}
      centered
    >
      <Modal.Header>
        <Modal.Title className="m-0">Publish Schedule</Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => {
            handleShowPublishSchedules(false);
          }}
        />
      </Modal.Header>
      <Formik
        enableReinitialize
        initialValues={{
          selectedMembers: selectedTeamMembers,
          projectId:
            selectedProject?.value !== 'all' ? selectedProject?.value : '',
          fromDate: '',
          toDate: '',
        }}
        validationSchema={Yup.object({
          fromDate: Yup.date().required('Please select start date'),
          toDate: Yup.date()
            .required('Please select end date')
            .min(
              Yup.ref('fromDate'),
              'End date must be equal or greater start date'
            ),
          selectedMembers: Yup.array()
            .required('Please select a team member')
            .min(1, 'Please select a team member'),
        })}
        onSubmit={(values) => {
          const formikValues = { ...values };
          if (formikValues.selectedMembers.includes('all')) {
            formikValues.selectedMembers = selectedTeamMember;
          }
          handlePublishSchedules(formikValues);
        }}
      >
        {(formikprops) => (
          <Form onSubmit={formikprops.handleSubmit}>
            <Modal.Body>
              <section>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="fromDate">
                      <Form.Label>
                        From Date <span className="text-danger">*</span>
                      </Form.Label>
                      <Flatpickr
                        onChange={([date]) => {
                          formikprops.setFieldValue('fromDate', date);
                        }}
                        placeholder=""
                        options={datePickerOptions}
                        className="form-control icon-calendar due-date"
                        name="fromDate"
                      />
                      <ErrorMessage
                        name="fromDate"
                        render={(msg) => (
                          <small className="text-danger">{msg}</small>
                        )}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="toDate">
                      <Form.Label>
                        To Date <span className="text-danger">*</span>
                      </Form.Label>
                      <Flatpickr
                        onChange={([date]) => {
                          formikprops.setFieldValue('toDate', date);
                        }}
                        placeholder=""
                        options={datePickerOptions}
                        className="form-control icon-calendar due-date"
                        name="toDate"
                      />
                      <ErrorMessage
                        name="toDate"
                        render={(msg) => (
                          <small className="text-danger">{msg}</small>
                        )}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <ProjectListDropdown
                  fieldName="projectId"
                  projectsList={projectsList}
                  handleChange={formikprops.handleChange}
                  handleProjectChange={handleProjectChange}
                  isDependedField
                  otherActions={clearTeamMemberFiled}
                />
                <MemberMultiSelectDropdown
                  id="publishSchedulesSelectInputRef"
                  name="selectedMembers"
                  labelText="Team Member(s)"
                  fromArray={sortedMembersList}
                  formProps={formikprops}
                  isDisabled={sortedMembersList.length < 1 && true}
                  innerRef={publishSchedulesSelectInputRef}
                  isAllTeamMemberOption
                  isAllTeamMemberValuesWithNoArray
                  requiredValueAs="userId"
                  showErrorMessage
                  isRequiredField
                  onChangeAction={handleTeamMembers}
                />
              </section>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
              <Button
                variant="link"
                onClick={() => {
                  handleShowPublishSchedules(false);
                }}
              >
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Publish
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

PublishSchedules.propTypes = {
  teamMembersList: PropTypes.array,
  projectsList: PropTypes.array,
  showPublishSchedules: PropTypes.bool,
  handleShowPublishSchedules: PropTypes.func,
  handlePublishSchedules: PropTypes.func,
  selectedProject: PropTypes.object,
  handleProjectChange: PropTypes.func,
};

export default PublishSchedules;
